import { configureStore } from '@reduxjs/toolkit'
import progressReducer from './reducers/progressSlice'

export default configureStore({
  reducer: {
    progress: progressReducer
  }
})
